import createIcon from '../../createIcon';

/**
 * @component @name NoCell
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41NDU0NyA2TDUuODQ1NDcgMi4zQzYuMTM1NDcgMS41NSA2Ljg2NTQ3IDEgNy43MTU0NyAxTDE3LjcxNTUgMS4wMUMxOC44MTU1IDEuMDEgMTkuNzE1NSAxLjkgMTkuNzE1NSAzVjE2LjE3TDE3LjcxNTUgMTQuMTdWNkg5LjU0NTQ3Wk0yMC40OTU1IDIyLjYxTDE5LjU4NTUgMjEuN0MxOS4yOTU1IDIyLjQ1IDE4LjU2NTUgMjMgMTcuNzE1NSAyM0g3LjcxNTQ3QzYuNjE1NDcgMjMgNS43MTU0NyAyMi4xIDUuNzE1NDcgMjFWNy44M0wyLjEwNTQ3IDQuMjJMMy41MTU0NyAyLjgxTDIxLjg5NTUgMjEuMTlMMjAuNDk1NSAyMi42MVpNMTUuODg1NSAxOEw3LjcxNTQ3IDkuODNWMThIMTUuODg1NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoCell = createIcon('NoCell', [
  [
    'path',
    {
      d: 'M9.54547 6L5.84547 2.3C6.13547 1.55 6.86547 1 7.71547 1L17.7155 1.01C18.8155 1.01 19.7155 1.9 19.7155 3V16.17L17.7155 14.17V6H9.54547ZM20.4955 22.61L19.5855 21.7C19.2955 22.45 18.5655 23 17.7155 23H7.71547C6.61547 23 5.71547 22.1 5.71547 21V7.83L2.10547 4.22L3.51547 2.81L21.8955 21.19L20.4955 22.61ZM15.8855 18L7.71547 9.83V18H15.8855Z',
      key: '133rwd',
    },
  ],
]);

export default NoCell;
